import { createIcon } from '@chakra-ui/react';

export const SearchIcon = createIcon({
  displayName: 'SearchIcon ',
  path: (
    <>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.7" clipPath="url(#clip0_1273_14853)">
          <mask id="mask0_1273_14853" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <path d="M16 0H0V16H16V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_1273_14853)">
            <path
              d="M7.66671 14.5C3.90004 14.5 0.833374 11.4333 0.833374 7.66667C0.833374 3.9 3.90004 0.833332 7.66671 0.833332C11.4334 0.833332 14.5 3.9 14.5 7.66667C14.5 11.4333 11.4334 14.5 7.66671 14.5ZM7.66671 1.83333C4.44671 1.83333 1.83337 4.45333 1.83337 7.66667C1.83337 10.88 4.44671 13.5 7.66671 13.5C10.8867 13.5 13.5 10.88 13.5 7.66667C13.5 4.45333 10.8867 1.83333 7.66671 1.83333Z"
              fill="currentColor"
            />
            <path
              d="M14.6666 15.1663C14.54 15.1663 14.4133 15.1197 14.3133 15.0197L12.98 13.6863C12.7866 13.493 12.7866 13.173 12.98 12.9797C13.1733 12.7863 13.4933 12.7863 13.6866 12.9797L15.02 14.313C15.2133 14.5063 15.2133 14.8263 15.02 15.0197C14.92 15.1197 14.7933 15.1663 14.6666 15.1663Z"
              fill="currentColor"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1273_14853">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  ),
});
